import {
    Home,
    Users,
    Star,
    ShoppingBag,
    Map,
    Monitor,
    Settings,
    MapPin,
    Activity,
    Command,
    Crop,
    Anchor,
    Server,
    CloudOff
} from 'react-feather';

export const MENUITEMS = [
    {
        title: 'Dashboard', icon: Home, type: 'link', path: '/dashboard', badgeType: 'primary', active: false
    },
    // {
    //     title: 'Feedback', icon: Command, type: 'link', path:'/feedback',active: false
    // },
    {
        title: 'Portal User', icon: Users, type: 'link', path: '/portalUser', active: false
    },
    // {
    //     title: 'Audit', icon: CloudOff, type: 'link', path:'/auditLog',active: false
    // },
    {
        title: 'Settings', icon: Settings, type: 'link', path: '/settings', active: false
    },
]
